import { Typography } from '@material-ui/core';
import React from 'react';

export default function RecommendationTitle() {
  return (
    <Typography variant='h4' component='p'>
      The best choice is:
    </Typography>
  );
}
